import React from 'react';
import { useTranslation } from 'react-i18next';
import { setMenuLanguage } from '../i18n';
import './LanguageSelector.css';

const languages = [
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' }
];

function LanguageSelector() {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (lng) => {
    i18n.changeLanguage(lng);
    setMenuLanguage(lng);
  };

  return (
    <div className="language-selector">
      <label className="language-label">{t('language.select')}</label>
      <select
        value={i18n.language}
        onChange={(e) => handleLanguageChange(e.target.value)}
        className="language-select"
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.flag} {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default LanguageSelector;
